import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import boulderChurchData from './data';

const BoulderChurch = () => {
  return <ProjectDetailView data={boulderChurchData} />;
};

export default BoulderChurch;
